import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

export const initPostHog = () => {
  if (!POSTHOG_KEY) {
    console.warn('PostHog key not found. Analytics will be disabled.');
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    // Session recording
    disable_session_recording: false,
    // Error tracking
    autocapture_exceptions: true,
  });

  console.log('PostHog initialized');
};

export const identifyUser = (userId: string, properties?: Record<string, unknown>) => {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, properties);
};

export const captureEvent = (event: string, properties?: Record<string, unknown>) => {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
};

export const captureException = (error: Error, context?: Record<string, unknown>) => {
  if (!POSTHOG_KEY) return;
  posthog.capture('$exception', {
    $exception_message: error.message,
    $exception_type: error.name,
    $exception_stack: error.stack,
    ...context,
  });
};

export { posthog };
